import useSWR from "swr";


type MonthlyDispatchRequests = {
  id: string;
  corporation_name: string;
  team_name: string;
  month: string;
  number: number;
  requested_at: string;
}[]
type PaginatedMonthlyDispatchRequests = {
  count: number;
  monthly_dispatch_requests: MonthlyDispatchRequests;
};
export const useFetchPaginatedMonthlyDispatchRequestsForTeamsBySalesmanId = (pageSize: number, currentPage: number, salesmanId?: string,) => {
  const fetcherKey = salesmanId ? `kuitan/salesmen/${salesmanId}/teams/dispatch/requests/monthly/paginated/?pageSize=${pageSize}&currentPage=${currentPage}` : null
  const { data: paginatedMonthlyDispatchRequests, error, isLoading } = useSWR<PaginatedMonthlyDispatchRequests>(fetcherKey)
  return { paginatedMonthlyDispatchRequests, isLoading, error };
};